"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAsset = exports.getAssetsModel = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _App = require("../App/App.config");
var getAssetUrl = function getAssetUrl() {
  return _App.ASSET_HOST;
};
var assetUrl = getAssetUrl();
var DEEPWEB = '/deepweb/assets';
var CONTENT_DAM = '/content/dam';

/**
 * Returns if the path is from asset server
 * @param {string} url - URL which we evaluate if it's asset or not
 */
var isAsset = function isAsset(url) {
  var assetsPaths = [DEEPWEB, CONTENT_DAM];
  var isAsset = assetsPaths.some(function (p) {
    return url.startsWith(p);
  });
  return isAsset;
};

/**
 * Returns a promise of the asset info
 * @param {string} url - URL of the asset
 */
exports.isAsset = isAsset;
var getAssetModel = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(asset) {
    var response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch("".concat(assetUrl).concat(asset, "/_jcr_content/metadata.json"));
          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();
          case 6:
            return _context.abrupt("return", _context.sent);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", []);
          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));
  return function getAssetModel(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Returns a promise of the all the assets information
 * @param {string[]} assets - array of assets url
 */
var getAssetsModel = function getAssetsModel(assets) {
  return Promise.all(assets.map(/*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(assetPath) {
      var assetUrl;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // replace deepweb/assets by content dam
              assetUrl = assetPath.startsWith(DEEPWEB) ? assetPath.replace(DEEPWEB, "".concat(CONTENT_DAM, "/cms-commons")) : assetPath;
              return _context2.abrupt("return", getAssetModel(assetUrl));
            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }()));
};
exports.getAssetsModel = getAssetsModel;